import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import morchaModel from './../../../assets/3d-models/MORCHA_MAIN_SET.glb';

export function Model(props) {
  const { nodes, materials } = useGLTF(morchaModel)
  return (
    <group {...props} dispose={null}>
      <group>
        <group position={[-0.126751, 0.963628, -1.172342]} scale={4.734711} />
        <group position={[-1.098548, 0.566408, -1.23215]} scale={1.280842}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube002.geometry}
            material={materials['Metal Paint']}
            scale={0.780737}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.j_kumar001.geometry}
            material={materials['Material.001']}
            position={[-0.118339, 0.498615, 0.035119]}
            scale={0.780737}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.j_kumar003.geometry}
            material={materials['Material.001']}
            position={[0.032153, 0.498615, -0.123432]}
            scale={0.780737}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.morcha001.geometry}
            material={materials['Material.003']}
            position={[-0.387312, -0.357579, 0.019726]}
            scale={0.780737}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.morcha002.geometry}
            material={materials['Material.003']}
            position={[0.012506, -0.357579, -0.392125]}
            scale={0.780737}
          />
        </group>
        <group position={[-0.12519, 0.701814, -1.243443]} scale={1.49073}>
          <group scale={0.670812}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Plane004.geometry}
              material={materials['Material.007']}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Plane004_1.geometry}
              material={materials['Material.008']}
            />
          </group>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.BASE_1004.geometry}
            material={materials['Material.001']}
            position={[0.02229, 0.337579, -0.098897]}
            scale={0.670812}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.BASE_1005.geometry}
            material={materials['Material.003']}
            position={[0.023172, -0.398624, -0.334361]}
            scale={0.670812}
          />
          <group
            position={[0.017334, -0.361927, 0.174908]}
            rotation={[Math.PI / 2, 0, 0]}
            scale={[0.143027, 0.154044, 0.095012]}>
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Plane001.geometry}
              material={materials['Material.012']}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Plane001_1.geometry}
              material={materials['Material.010']}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.Plane001_2.geometry}
              material={materials['Material.009']}
            />
          </group>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane003.geometry}
            material={materials['Material.006']}
            position={[0.303761, -0.460438, 0.187861]}
            rotation={[-Math.PI, 0, -Math.PI]}
            scale={[0.014284, 0.012649, 0.031012]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane005.geometry}
            material={materials['Material.006']}
            position={[0.303761, -0.460438, -0.386618]}
            scale={[0.014284, 0.012649, 0.031012]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane008.geometry}
            material={materials['Material.006']}
            position={[-0.259985, -0.460438, -0.386618]}
            scale={[0.014284, 0.012649, 0.031012]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Plane009.geometry}
            material={materials['Material.006']}
            position={[-0.259985, -0.460438, 0.187861]}
            rotation={[-Math.PI, 0, -Math.PI]}
            scale={[0.014284, 0.012649, 0.031012]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Torus.geometry}
            material={materials['Material.011']}
            position={[-0.422623, 0.441437, 0.030903]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
            scale={[0.014703, 0.014217, 0.014703]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Torus001.geometry}
            material={materials['Material.011']}
            position={[0.474892, 0.441437, 0.030903]}
            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
            scale={[0.014703, 0.014217, 0.014703]}
          />
        </group>
        <group position={[0.910036, 0.568158, -1.242291]} scale={1.30776}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Cube001.geometry}
            material={materials['Metal Paint']}
            scale={0.764666}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.j_kumar005.geometry}
            material={materials['Material.001']}
            position={[0.121823, 0.494676, 0.025408]}
            scale={0.764666}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.j_kumar006.geometry}
            material={materials['Material.001']}
            position={[-0.029051, 0.494677, -0.115467]}
            scale={0.764666}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.morcha004.geometry}
            material={materials['Material.003']}
            position={[0.383966, -0.349764, 0.040424]}
            scale={0.764666}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.morcha005.geometry}
            material={materials['Material.003']}
            position={[-0.020493, -0.347232, -0.376299]}
            scale={0.764666}
          />
        </group>
        <group position={[0.033505, 0.106254, -1.781096]} />
      </group>
    </group>
  )
}

useGLTF.preload("/static/3d-models/MORCHA_MAIN_SET.glb")
